import React, { Fragment, useEffect } from "react";

import CustomButton from "../../../../globals/components/button";
import CustomModal from "../../../../globals/components/Modal";
// import CustomCard from "../../../../globals/components/Card";
import "../Modal.less";
import { useDispatch } from "react-redux";
import { showContentPreviewmodal } from "../../content.slice";
import TemplateData from "./templateDetailFill";
import { peviewDataGet, peviewfromcontentDataGet } from "../../content.Action";
import { Form } from "antd";

import { PDFReader } from "reactjs-pdf-reader";

const ContentPreviewModal = (props) => {
  const [form] = Form.useForm();

  const {
    intl: { formatMessage },
    content,
  } = props;

  const dispatch = useDispatch();

  const modelClose = async () => {
    dispatch(showContentPreviewmodal({ visible: false, record: {} }));
  };
  const {
    contentPreviewRecord,

    isContetPreviewLoading,
    isContentPreviewVisible,
    contentPreviewModaType,
    contentFillData,
    previewType = "",
    backendJsonRecord = [],
  } = content;
  useEffect(() => {
    if (isContentPreviewVisible) {
      form.resetFields();
      contentFillData.forEach((element) => {
        form.setFieldsValue({ [`${element.label}`]: undefined });
      });
    }
    // eslint-disable-next-line
  }, [isContentPreviewVisible]);
  const onSubmitData = async (form) => {
    await form.validateFields();
    let data = {
      // id: contentPreviewRecord?._id,
      contractHtml: contentPreviewRecord.contents,
      templateJson: [{fields:contentFillData}],
      
      // contentName: values?.contentName,
      // contentType: values?.contentType,
      // content: contents,
      // templete_ids:
      //   values.templete_ids && Array.isArray(values.templete_ids)
      //     ? values.templete_ids
      //     : [values.templete_ids],
    };
    if (previewType === "createfromcontent") {
      dispatch(peviewfromcontentDataGet({ data }));
    } else {
      dispatch(peviewDataGet({ data }));
      
    }
  };
  return (
    <>
      <CustomModal
        width={1200}
        maskClosable={false}
        title={formatMessage({id:"preview"})}
        destroyOnClose={true}
        placement="right"
        onCancel={() => {
          modelClose();
          form.resetFields();
        }}
        open={isContentPreviewVisible}
        footer={
          <Fragment>
            <CustomButton
              // loading={isContetPreviewLoading}
              onClick={() => {
                form.resetFields();
                modelClose();
              }}
            >
              {formatMessage({ id: "close" })}
            </CustomButton>
            {contentPreviewModaType === "createfromcontent" ? (
              <CustomButton
                style={{ margin: "0 0 0 20px" }}
                type="primary"
                onClick={() => {
                  onSubmitData(form);
                  // form.resetFields();
                }}
                key={"submit"}
                loading={isContetPreviewLoading}
              >
                {formatMessage({ id: "submit" })}
              </CustomButton>
            ) : (
              ""
            )}
          </Fragment>
        }
      >
        {contentPreviewModaType === "createfromcontent" ? (
          <Form
            form={form}
            colon={false}

            // initialValues={workflowdetails.templete_ids}
          >
            <TemplateData {...props} form={form} />
          </Form>
        ) : (
          <div
            style={{
              overflowY: "scroll",
              height: 580,
              border: "1px solid rgba(0, 0, 0, 0.3)",
              backgroundColor: "#E6E6E6",
            }}
          >
            <PDFReader
              page={1}
              style={{ maxheight: "500px" }}
              showAllPage={true}
              // width={300}
              url={contentPreviewRecord}
            />
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default ContentPreviewModal;
